import React from 'react'

const FlowchartUtils = () => {
  const generateId = (name, index, parentId = '') =>
    `${parentId}_${(name || '').replace(/\s+/g, '_').toLowerCase()}_${index}`

  const renderElements = (
    items,
    level = 0,
    parentId = null,
    isChildren = false,
    parentColor = null,
    parentTextColor = 'black',
  ) => {
    const elements = []

    items.forEach((item, index) => {
      const elementId = generateId(item.name, index, parentId || 'root')

      const childrenRelations = []
      if (item.children && item.children.length > 0) {
        item.children.forEach((child, childIndex) => {
          const childId = generateId(child.name, childIndex, elementId)
          childrenRelations.push({
            targetId: childId,
            targetAnchor: 'top',
            sourceAnchor: 'bottom',
            style: {
              strokeColor: item.color || 'black',
              strokeWidth: 2,
              strokeDasharray: '5,5',
              endMarker: true,
              endMarkerSize: 8,
            },
          })
        })
      }

      const sequentialRelations = []
      if (!isChildren && index < items.length - 1) {
        const nextElementId = generateId(
          items[index + 1].name,
          index + 1,
          parentId || 'root',
        )
        sequentialRelations.push({
          targetId: nextElementId,
          targetAnchor: 'left',
          sourceAnchor: 'right',
          style: {
            strokeColor: 'blue',
            strokeWidth: 2,
            endMarker: true,
            endMarkerSize: 8,
          },
        })
      }

      const allRelations = [...childrenRelations, ...sequentialRelations]

      const connectionTypes = {
        hasIncomingVertical: isChildren,
        hasOutgoingVertical: childrenRelations.length > 0,
        hasIncomingHorizontal: !isChildren && index > 0,
        hasOutgoingHorizontal: !isChildren && index < items.length - 1,
      }

      elements.push({
        id: elementId,
        name: item.name,
        relations: allRelations,
        level,
        isChildren,
        color: item.color || parentColor,
        textColor: item.textColor || parentTextColor || 'black',
        connectionTypes,
        type: item.type || 'annotation',
      })

      if (item.children && item.children.length > 0) {
        const childrenElements = renderElements(
          item.children,
          level + 1,
          elementId,
          true,
          item.color || parentColor,
          item.textColor || parentTextColor || 'black',
        )
        elements.push(...childrenElements)
      }
    })

    return elements
  }

  const organizeElementsByLevel = (elements) => {
    const elementsByLevel = {}
    elements.forEach((element) => {
      if (!elementsByLevel[element.level]) {
        elementsByLevel[element.level] = []
      }
      elementsByLevel[element.level].push(element)
    })
    return elementsByLevel
  }

  return {
    generateId,
    renderElements,
    organizeElementsByLevel,
  }
}

export default FlowchartUtils
